import { render, staticRenderFns } from "./SeriesEdit.vue?vue&type=template&id=19b6c7d9&"
import script from "./SeriesEdit.vue?vue&type=script&lang=js&"
export * from "./SeriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports